/* global axios */
import ApiClient from './ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(formData) {
    return axios.post(this.url, { form: formData });
  }

  update(id, formData) {
    return axios.patch(`${this.url}/${id}`, { form: formData });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getSubmissions(id, params) {
    return axios.get(`${this.url}/${id}/submissions`, { params });
  }

  getAnalytics(id) {
    return axios.get(`${this.url}/${id}/analytics`);
  }
}

export default new FormsAPI();
